import { createContext, useState, useEffect } from "react";
import clienteAxios from "../config/clienteAxios";

const FooterContext = createContext();

const FooterProvider = ({ children }) => {
  const [footerCats, setFooterCats] = useState([]);

  useEffect(() => {
    getAllFooterCats().then((response) => {
      const noDeletedCats = response.filter((cat) => !cat.deleted);
      setFooterCats(noDeletedCats);
    });
  }, []);

  const getAllFooterCats = async () => {
    try {
      const { data } = await clienteAxios("/footerCategory/getAll");
      return data.allFooterCat;
    } catch (error) {
      console.log(error);
    }
  };

  const createFooterCat = async (category) => {
    try {
      const { data } = await clienteAxios.post("/footerCategory/create", category);
      return data;
    } catch (error) {
      console.log(error);
    }
  };

  const updateFooterCat = async (category) => {
    try {
      const { data } = await clienteAxios.put("/footerCategory/update", category);
      return data;
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <FooterContext.Provider value={{ footerCats, createFooterCat, updateFooterCat }}>
      {children}
    </FooterContext.Provider>
  );
};

export { FooterProvider };

export default FooterContext;
